import { gql } from '@apollo/client';

// Fields restricted to bbb_client_not_in_meeting role for pre-join compatibility
export const CURRENT_USER_SUBSCRIPTION = gql`
subscription userCurrentSubscription {
  user_current {
    authToken
    authed
    banned
    color
    currentlyInMeeting
    disconnected
    ejectReason
    ejectReasonCode
    ejected
    expired
    extId
    guest
    guestStatus
    isModerator
    joinErrorCode
    joinErrorMessage
    joined
    loggedOut
    logoutUrl
    name
    presenter
    registeredAt
    registeredOn
    userId
    guestStatusDetails {
      guestLobbyMessage
      positionInWaitingQueue
      isAllowed
    }
    meeting {
      ended
      endedReasonCode
      endedByUserName
      logoutUrl
    }
  }
}
`;

export default CURRENT_USER_SUBSCRIPTION;
